import {
  getCollectionFieldTraitOptions,
  getCollectionOptionsForSelect,
  getFieldOptionsForProgressSelect,
} from '../pluginComponentApi';
import { progressValue, progressTotal } from './consts';

export default async function (editor, opt = {}) {
  const traitManager = editor.TraitManager;
  const { bindCollectionOptions, projectId, version, collections, installedPlugins } = opt;
  console.log('🚀 ~ traits: progressBar ~ opt:', opt);
  const { collection, session, sessionTenant, sessionUserSettings, sessionSubTenant } =
    bindCollectionOptions;
  // Progress Value Constant
  const progressValueCollectionFieldName = collection
    ? `${progressValue}-${collection.collectionId}`
    : '';
  const progressValueSessionFieldName = `${progressValue}-session`;
  const progressValueSessionTenantFieldName = `${progressValue}-session-tenant`;
  const progressValueSessionUserSettingsFieldName = `${progressValue}-session-userSettings`;
  const progressValueSessionSubTenantFieldName = `${progressValue}-session-sub-tenant`;
  const progressValuePreviousActionFormdata = `${progressValue}-previous-action-formdata`;
  const progressValuePreviousActionResponse = `${progressValue}-previous-action-response`;
  const progressValueBrowserStorage = `${progressValue}-browser-storage`;
  const progressValueStorageKey = `${progressValue}-storage-key`;

  // Progress Total Constant
  const progressTotalCollectionFieldName = collection
    ? `${progressTotal}-${collection.collectionId}`
    : '';
  const progressTotalSessionFieldName = `${progressTotal}-session`;
  const progressTotalSessionTenantFieldName = `${progressTotal}-session-tenant`;
  const progressTotalSessionUserSettingsFieldName = `${progressTotal}-session-userSettings`;
  const progressTotalSessionSubTenantFieldName = `${progressTotal}-session-sub-tenant`;
  const progressTotalPreviousActionFormdata = `${progressTotal}-previous-action-formdata`;
  const progressTotalPreviousActionResponse = `${progressTotal}-previous-action-response`;
  const progressTotalBrowserStorage = `${progressTotal}-browser-storage`;
  const progressTotalStorageKey = `${progressTotal}-storage-key`;

  const style = document.createElement('style');
  style.innerHTML = `   .checkmark::after {
            left: 4px;
            top: 4px;
        }
        checkbox{
        all:unset;
        }
        select option:first-child {
            color: grey;
        }
        select.empty {
            color: grey;
        }
        select option[disabled]:first-child {
            display: none;
        }
        input[type=webconnect-text] {
            display:block;
        }`;
  document.head.appendChild(style);
  const multiTenantPlugin =
    installedPlugins && installedPlugins.find((plugin) => plugin.code === 'MULTI_TENANT_SAAS');
  const hasMultiTenantPlugin = !!multiTenantPlugin;
  if (collection || session || sessionTenant || sessionUserSettings || sessionSubTenant) {
    traitManager.addType(progressValue, {
      createInput({ trait }) {
        const el = document.createElement('div');
        const customLabel = 'Get Value From';
        el.classList.add('custom-field');
        el.innerHTML = `    
        <div id="${progressValue}">
          <div class="gjs-container">
            <div class="gjs-row">
              <div class="gjs-label-wrp">
                <div class="gjs-label" title="Get Value">Get Value</div>
              </div>
              <div id="select-getProgressValueFrom-div" class="gjs-field-wrp gjs-field-wrp--select-getProgressValueFrom">
                <div class="gjs-field">
                  <select class="select-getProgressValueFrom form-control form-control-sm options-light">
                    <option value="" selected>- Get Value -</option>
                    ${
                      collection &&
                      `<option value="collection">${customLabel} ${collection.collectionTitle}</option>`
                    }
                    ${
                      session &&
                      `
                      <option value="session">${customLabel} Logged In User</option>
                    `
                    }
                    ${
                      sessionTenant &&
                      hasMultiTenantPlugin &&
                      `
                      <option value="sessionTenant">${customLabel} Logged In ${sessionTenant.collectionTitle}</option>
                    `
                    }
                    ${
                      sessionUserSettings &&
                      hasMultiTenantPlugin &&
                      `
                      <option value="sessionUserSettings">${customLabel} Logged In ${sessionUserSettings.collectionTitle}</option>
                    `
                    }
                    ${
                      sessionSubTenant &&
                      hasMultiTenantPlugin &&
                      `
                      <option value="sessionSubTenant">${customLabel} Logged In ${sessionSubTenant.collectionTitle}</option>
                    `
                    }
                    <option value="previousActionResponse">${customLabel} Browser Session</option>
                    <option value="previousActionFormData">${customLabel} Browser Session Form Data</option>
                    <option value="browserStorage">${customLabel} Collection (Browser Storage)</option>
                  </select>
                </div>
              </div>
            </div>
          </div>

          <div id="get-progressValue-browser-key" class="gjs-container" style="display: none;">
            <div class="gjs-row">
              <div id="entityCollection-label-div" class="gjs-label-wrp">
                <div class="gjs-label" title="Collection Name">Collection Name</div>
              </div>
              <div id="browserStorageProgressValueKeyDiv" class="gjs-field-wrp gjs-field-wrp--json-field-progressValue-div" style="display: none;">
                <div class="gjs-field">
                  <select class="browserStorageProgressValueKey form-control form-control-sm options-light"> </select>
                </div>
              </div>
            </div>
             <div class="gjs-row">
              <div id="entityField-label-div" class="gjs-label-wrp">
                <div class="gjs-label" title="Field Name">Field Name</div>
              </div>
              <div id="browserStorageProgressValueFieldDiv" class="gjs-field-wrp gjs-field-wrp--json-field-progressValue-div" style="display: none;">
                <div class="gjs-field">
                  <select class="browserStorageFieldProgressValueKey form-control form-control-sm options-light"> </select>
                </div>
              </div>
            </div>
          </div>

          <div id="get-progressValue-field-container" class="gjs-container" style="display: none;">
            <div class="gjs-row">
              <div id="field-label-progressValue-div" class="gjs-label-wrp">
                <div class="gjs-label" title="Field Name">Field Name</div>
              </div>
              <div id="collection-label-progressValue-div" class="gjs-label-wrp" style="display: none;">
                <div class="gjs-label" title="Collection Name">Collection Name</div>
              </div>
              <div id="select-progressValue-div" class="gjs-field-wrp gjs-field-wrp--select-progressValue-div" style="display: none;">
                <div class="gjs-field gjs-field--select-progressValue-div">
                  <select class="selectProgressValueField form-control form-control-sm options-light"> </select>
                </div>
              </div>
              <div id="json-field-progressValue-div" class="gjs-field-wrp gjs-field-wrp--json-field-progressValue-div" style="display: none;">
                <div class="gjs-field">
                  <input class="jsonFieldprogressValue form-control form-control-sm" placeholder="Ex. name" />
                </div>
              </div>
            </div>
          </div>
        </div>
    `;

        const selectGetTextFrom = el.querySelector('.select-getProgressValueFrom');
        const getContentFieldContainer = el.querySelector('#get-progressValue-field-container');
        const getBrowserKey = el.querySelector('#get-progressValue-browser-key');

        const fieldLabelDiv = el.querySelector('#field-label-progressValue-div');
        const collectionLabelDiv = el.querySelector('#collection-label-progressValue-div');
        const selectFieldDiv = el.querySelector('#select-progressValue-div');
        const selectProgressValueField = el.querySelector('.selectProgressValueField');

        const jsonFieldDiv = el.querySelector('#json-field-progressValue-div');
        const jsonFieldprogressValue = el.querySelector('.jsonFieldprogressValue');
        const browserStorageProgressValueKeyDiv = el.querySelector(
          '#browserStorageProgressValueKeyDiv',
        );
        const browserStorageProgressValueKey = el.querySelector('.browserStorageProgressValueKey');
        const browserStorageProgressValueFieldDiv = el.querySelector(
          '#browserStorageProgressValueFieldDiv',
        );
        const browserStorageFieldProgressValueKey = el.querySelector(
          '.browserStorageFieldProgressValueKey',
        );
        jsonFieldprogressValue.addEventListener('change', async (ev) => {});
        if (selectGetTextFrom) {
          selectGetTextFrom.addEventListener('change', async (ev) => {
            selectProgressValueField.innerHTML = '';
            let optionHtml = `<option value="" selected>None</option>`;
            if (selectGetTextFrom.value) {
              getContentFieldContainer.style.display = 'block';
              if (selectGetTextFrom.value === 'browserStorage') {
                getBrowserKey.style.display = 'block';
              } else {
                getBrowserKey.style.display = 'none';
              }
            } else {
              getContentFieldContainer.style.display = 'none';
            }
            if (selectGetTextFrom.value === 'session') {
              optionHtml = session ? getFieldOptionsForProgressSelect(session.options) : '';
              selectFieldDiv.style.display = 'block';
              fieldLabelDiv.style.display = 'block';
              jsonFieldDiv.style.display = 'none';
              collectionLabelDiv.style.display = 'none';
            } else if (selectGetTextFrom.value === 'sessionTenant') {
              optionHtml = sessionTenant
                ? getFieldOptionsForProgressSelect(sessionTenant.options)
                : '';
              selectFieldDiv.style.display = 'block';
              fieldLabelDiv.style.display = 'block';
              jsonFieldDiv.style.display = 'none';
              collectionLabelDiv.style.display = 'none';
            } else if (selectGetTextFrom.value === 'sessionUserSettings') {
              optionHtml = sessionUserSettings
                ? getFieldOptionsForProgressSelect(sessionUserSettings.options)
                : '';
              selectFieldDiv.style.display = 'block';
              fieldLabelDiv.style.display = 'block';
              jsonFieldDiv.style.display = 'none';
              collectionLabelDiv.style.display = 'none';
            } else if (selectGetTextFrom.value === 'sessionSubTenant') {
              optionHtml = sessionSubTenant
                ? getFieldOptionsForProgressSelect(sessionSubTenant.options)
                : '';
              selectFieldDiv.style.display = 'block';
              fieldLabelDiv.style.display = 'block';
              jsonFieldDiv.style.display = 'none';
              collectionLabelDiv.style.display = 'none';
            } else if (selectGetTextFrom.value === 'collection') {
              optionHtml = collection ? getFieldOptionsForProgressSelect(collection.options) : '';
              selectFieldDiv.style.display = 'block';
              fieldLabelDiv.style.display = 'block';
              jsonFieldDiv.style.display = 'none';
              collectionLabelDiv.style.display = 'none';
            } else if (
              ['previousActionResponse', 'previousActionFormData'].includes(selectGetTextFrom.value)
            ) {
              jsonFieldDiv.style.display = 'block';
              fieldLabelDiv.style.display = 'block';
              selectFieldDiv.style.display = 'none';
              collectionLabelDiv.style.display = 'none';
            } else if (selectGetTextFrom.value === 'browserStorage') {
              browserStorageProgressValueKey.innerHTML = collections
                ? getCollectionOptionsForSelect(collections)
                : '';
              browserStorageFieldProgressValueKey.innerHTML = `<option value="" selected>None</option>`;
              browserStorageProgressValueFieldDiv.style.display = 'block';
              browserStorageProgressValueKeyDiv.style.display = 'block';
              selectFieldDiv.style.display = 'none';
              collectionLabelDiv.style.display = 'none';
              jsonFieldDiv.style.display = 'none';
              fieldLabelDiv.style.display = 'none';
            } else {
              jsonFieldDiv.style.display = 'none';
              selectFieldDiv.style.display = 'none';
              fieldLabelDiv.style.display = 'none';
              collectionLabelDiv.style.display = 'none';
              getContentFieldContainer.style.display = 'none';
              getBrowserKey.style.display = 'none';
            }
            jsonFieldprogressValue.value = '';
            browserStorageProgressValueKey.value = '';
            selectProgressValueField.innerHTML = optionHtml;
          });
        }

        browserStorageProgressValueKey.addEventListener('change', async (ev) => {
          const selectedCollection = collections.find(
            (col) => col.collectionName === ev.target.value,
          );
          const fields = await getCollectionFieldTraitOptions(selectedCollection, collections);
          browserStorageFieldProgressValueKey.innerHTML = getFieldOptionsForProgressSelect(fields);
        });

        return el;
      },
      onEvent({ elInput, component }) {
        const select = elInput.querySelector('.selectProgressValueField');
        const selectFieldDiv = elInput.querySelector('#select-progressValue-div');
        const jsonFieldprogressValue = elInput.querySelector('.jsonFieldprogressValue');
        const browserStorageProgressValueKey = elInput.querySelector(
          '.browserStorageProgressValueKey',
        );
        const browserStorageFieldProgressValueKey = elInput.querySelector(
          '.browserStorageFieldProgressValueKey',
        );
        const selectGetTextFrom = document.querySelector('.select-getProgressValueFrom');
        const selectGetTextFromValue = selectGetTextFrom ? selectGetTextFrom.value : '';
        let selectFieldValue = select.value || '';
        let jsonFieldValue = jsonFieldprogressValue.value || '';
        let browserStorageProgressValueKeyValue = browserStorageProgressValueKey.value || '';
        let browserStorageFieldProgressValueKeyValue =
          browserStorageFieldProgressValueKey.value || '';
        const selectedOption = select.options[select.selectedIndex];
        const fieldType = selectedOption ? selectedOption.getAttribute('type') : 'text';

        if (selectFieldValue.includes("'")) {
          selectFieldValue = selectFieldValue.split("'").join('"');
        }

        if (selectGetTextFromValue) {
          component.set('getProgressValueFrom', selectGetTextFromValue);
          let attr = component.getAttributes();
          [
            progressValueCollectionFieldName,
            progressValueSessionFieldName,
            progressValueSessionTenantFieldName,
            progressValueSessionUserSettingsFieldName,
            progressValueSessionSubTenantFieldName,
            progressValuePreviousActionFormdata,
            progressValuePreviousActionResponse,
            progressValueBrowserStorage,
            progressValueStorageKey,
          ].forEach((key) => {
            if (attr[key]) delete attr[key];
          });
          attr['data-row'] = 'generated';
          component.setAttributes(attr);
          if (selectFieldValue && selectGetTextFromValue === 'session') {
            component.addAttributes({ [progressValueSessionFieldName]: selectFieldValue });
          } else if (selectFieldValue && selectGetTextFromValue === 'sessionTenant') {
            component.addAttributes({ [progressValueSessionTenantFieldName]: selectFieldValue });
          } else if (selectFieldValue && selectGetTextFromValue === 'sessionUserSettings') {
            component.addAttributes({
              [progressValueSessionUserSettingsFieldName]: selectFieldValue,
            });
          } else if (selectFieldValue && selectGetTextFromValue === 'sessionSubTenant') {
            component.addAttributes({
              [progressValueSessionSubTenantFieldName]: selectFieldValue,
            });
          } else if (selectGetTextFromValue === 'collection') {
            if (selectFieldValue) {
              component.addAttributes({
                [progressValueCollectionFieldName]: selectFieldValue,
                'data-field-type': fieldType,
              });
            }
          } else if (selectGetTextFromValue === 'previousActionResponse') {
            attr[progressValuePreviousActionResponse] = jsonFieldValue ? jsonFieldValue : attr.name;
            delete attr[progressValueCollectionFieldName];
            delete attr[progressValuePreviousActionFormdata];
            delete attr[progressValueBrowserStorage];
            component.setAttributes(attr);
            selectFieldDiv.style.display = 'none';
          } else if (selectGetTextFromValue === 'previousActionFormData') {
            attr[progressValuePreviousActionFormdata] = jsonFieldValue ? jsonFieldValue : attr.name;
            delete attr[progressValueCollectionFieldName];
            delete attr[progressValuePreviousActionResponse];
            delete attr[progressValueBrowserStorage];
            component.setAttributes(attr);
            selectFieldDiv.style.display = 'none';
          } else if (selectGetTextFromValue === 'browserStorage') {
            attr[progressValueBrowserStorage] = browserStorageFieldProgressValueKeyValue
              ? browserStorageFieldProgressValueKeyValue
              : attr.name;
            attr[progressValueStorageKey] = browserStorageProgressValueKeyValue
              ? `entity_${browserStorageProgressValueKeyValue}`
              : attr.name;
            delete attr[progressValueCollectionFieldName];
            delete attr[progressValuePreviousActionFormdata];
            delete attr[progressValuePreviousActionResponse];
            component.setAttributes(attr);
            selectFieldDiv.style.display = 'none';
          }
        } else {
          const attr = component.getAttributes();
          delete attr[progressValueSessionFieldName];
          delete attr[progressValueSessionTenantFieldName];
          delete attr[progressValueSessionUserSettingsFieldName];
          delete attr[progressValueSessionSubTenantFieldName];
          delete attr[progressValueCollectionFieldName];
          delete attr['data-field-type'];
          delete attr[progressValuePreviousActionResponse];
          delete attr[progressValuePreviousActionFormdata];
          delete attr[progressValueBrowserStorage];
          delete attr[progressValueStorageKey];
          component.setAttributes(attr);
          component.set('getProgressValueFrom', '');
        }
      },
      async onUpdate({ elInput, component }) {
        const attr = component.getAttributes();
        //Removes empty attribute key
        delete attr[''];
        const getProgressValueFrom = component.get('getProgressValueFrom');
        const selectFieldDiv = elInput.querySelector('#select-progressValue-div');
        const selectProgressValueField = elInput.querySelector('.selectProgressValueField');
        const getContentFieldContainer = elInput.querySelector(
          '#get-progressValue-field-container',
        );
        const getBrowserKey = elInput.querySelector('#get-progressValue-browser-key');
        const fieldLabelDiv = elInput.querySelector('#field-label-progressValue-div');
        const collectionLabelDiv = elInput.querySelector('#collection-label-progressValue-div');
        const jsonFieldDiv = elInput.querySelector('#json-field-progressValue-div');
        const jsonFieldprogressValue = elInput.querySelector('.jsonFieldprogressValue');
        const selectGetTextFrom = elInput.querySelector('.select-getProgressValueFrom');

        const browserStorageProgressValueKeyDiv = elInput.querySelector(
          '#browserStorageProgressValueKeyDiv',
        );
        const browserStorageProgressValueKey = elInput.querySelector(
          '.browserStorageProgressValueKey',
        );
        const browserStorageProgressValueFieldDiv = elInput.querySelector(
          '#browserStorageProgressValueFieldDiv',
        );
        const browserStorageFieldProgressValueKey = elInput.querySelector(
          '.browserStorageFieldProgressValueKey',
        );
        let previousActionFormDataValue = attr[progressValuePreviousActionFormdata] || '';
        let previousActionResponseFieldValue = attr[progressValuePreviousActionResponse] || '';
        let entityStorageValue = attr[progressValueBrowserStorage] || '';
        let storageKeyValue = attr[progressValueStorageKey] || '';
        let jsonFieldValue = '';
        let browserStorageProgressValueKeyValue = '';
        let browserStorageFieldProgressValueKeyValue = '';
        if (selectGetTextFrom) {
          selectGetTextFrom.value = getProgressValueFrom || '';
        }

        if (
          previousActionFormDataValue ||
          previousActionResponseFieldValue ||
          entityStorageValue ||
          storageKeyValue
        ) {
          if (previousActionFormDataValue) {
            jsonFieldValue = previousActionFormDataValue;
          } else if (previousActionResponseFieldValue) {
            jsonFieldValue = previousActionResponseFieldValue;
          } else if (entityStorageValue || storageKeyValue) {
            browserStorageProgressValueKeyValue = storageKeyValue.replace('entity_', '');
            browserStorageFieldProgressValueKeyValue = entityStorageValue;
          }
        }

        const sessionFieldValue = attr[progressValueSessionFieldName] || '';
        const sessionTenantFieldValue = attr[progressValueSessionTenantFieldName] || '';
        const sessionUserSettingsFieldValue = attr[progressValueSessionUserSettingsFieldName] || '';
        const sessionSubTenantFieldValue = attr[progressValueSessionSubTenantFieldName] || '';
        const collectionFieldValue = attr[progressValueCollectionFieldName] || '';

        if (getProgressValueFrom) {
          getContentFieldContainer.style.display = 'block';
          let optionHtml = `<option value="" >None</option>`;
          switch (getProgressValueFrom) {
            case 'session':
              selectFieldDiv.style.display = 'block';
              optionHtml = session ? getFieldOptionsForProgressSelect(session.options) : '';
              selectProgressValueField.innerHTML = optionHtml;
              selectProgressValueField.value = sessionFieldValue;
              break;
            case 'sessionTenant':
              selectFieldDiv.style.display = 'block';
              optionHtml = sessionTenant
                ? getFieldOptionsForProgressSelect(sessionTenant.options)
                : '';
              selectProgressValueField.innerHTML = optionHtml;
              selectProgressValueField.value = sessionTenantFieldValue;
              break;
            case 'sessionUserSettings':
              selectFieldDiv.style.display = 'block';
              optionHtml = sessionUserSettings
                ? getFieldOptionsForProgressSelect(sessionUserSettings.options)
                : '';
              selectProgressValueField.innerHTML = optionHtml;
              selectProgressValueField.value = sessionUserSettingsFieldValue;
              break;
            case 'sessionSubTenant':
              selectFieldDiv.style.display = 'block';
              optionHtml = sessionSubTenant
                ? getFieldOptionsForProgressSelect(sessionSubTenant.options)
                : '';
              selectProgressValueField.innerHTML = optionHtml;
              selectProgressValueField.value = sessionSubTenantFieldValue;
              break;
            case 'collection':
              selectFieldDiv.style.display = 'block';
              optionHtml = collection ? getFieldOptionsForProgressSelect(collection.options) : '';
              selectProgressValueField.innerHTML = optionHtml;
              selectProgressValueField.value = collectionFieldValue;
              break;
            case 'previousActionResponse':
            case 'previousActionFormData':
              jsonFieldDiv.style.display = 'block';
              jsonFieldprogressValue.value = jsonFieldValue;
              break;
            case 'browserStorage':
              getBrowserKey.style.display = 'block';
              browserStorageProgressValueKeyDiv.style.display = 'block';
              browserStorageProgressValueFieldDiv.style.display = 'block';
              fieldLabelDiv.style.display = 'none';
              browserStorageProgressValueKey.innerHTML = collections
                ? getCollectionOptionsForSelect(collections)
                : '';
              browserStorageProgressValueKey.value = browserStorageProgressValueKeyValue;
              const entityCollection = collections.find(
                (col) => col.collectionName === browserStorageProgressValueKeyValue,
              );
              const fields = await getCollectionFieldTraitOptions(entityCollection, collections);
              browserStorageFieldProgressValueKey.innerHTML =
                getFieldOptionsForProgressSelect(fields);
              browserStorageFieldProgressValueKey.value = browserStorageFieldProgressValueKeyValue;
              break;
            default:
              jsonFieldDiv.style.display = 'none';
              selectFieldDiv.style.display = 'none';
              collectionLabelDiv.style.display = 'none';
              break;
          }
        } else {
          getContentFieldContainer.style.display = 'none';
          jsonFieldDiv.style.display = 'none';
          selectFieldDiv.style.display = 'none';
          collectionLabelDiv.style.display = 'none';
        }
      },
    });
    traitManager.addType(progressTotal, {
      createInput({ trait }) {
        const el = document.createElement('div');
        const customLabel = 'Get Total From';
        el.classList.add('custom-field');
        el.innerHTML = `
        <div id="${progressTotal}">

        <div class="gjs-container">
            <div class="gjs-row">
              <div class="gjs-label-wrp">
                <div class="gjs-label" title="Get Total">Get Total</div>
              </div>
              <div id="select-getprogressTotalFrom-div" class="gjs-field-wrp gjs-field-wrp--select-getprogressTotalFrom">
                <div class="gjs-field">
                  <select class="select-getprogressTotalFrom form-control form-control-sm options-light">
                    <option value="FIXED" selected> Fixed Value </option>
                    ${
                      collection &&
                      `<option value="collection">${customLabel} ${collection.collectionTitle}</option>`
                    }
                    ${
                      session &&
                      `
                      <option value="session">${customLabel} Logged In User</option>
                    `
                    }
                    ${
                      sessionTenant &&
                      hasMultiTenantPlugin &&
                      `
                      <option value="sessionTenant">${customLabel} Logged In ${sessionTenant.collectionTitle}</option>
                    `
                    }
                    ${
                      sessionUserSettings &&
                      hasMultiTenantPlugin &&
                      `
                      <option value="sessionUserSettings">${customLabel} Logged In ${sessionUserSettings.collectionTitle}</option>
                    `
                    }
                    ${
                      sessionSubTenant &&
                      hasMultiTenantPlugin &&
                      `
                      <option value="sessionSubTenant">${customLabel} Logged In ${sessionSubTenant.collectionTitle}</option>
                    `
                    }
                    <option value="previousActionResponse">${customLabel} Browser Session</option>
                    <option value="previousActionFormData">${customLabel} Browser Session Form Data</option>
                    <option value="browserStorage">${customLabel} Collection (Browser Storage)</option>
                  </select>
                </div>
              </div>
            </div>
          </div>

        <div id="total-div" class="gjs-container">
          <div class="gjs-row">
              <div class="gjs-label-wrp">
                <div class="gjs-label" title="Total">Total</div>
              </div>
              <div id="totalField-div" class="gjs-field-wrp gjs-field-wrp--select-totalField">
                <div class="gjs-field">
                <input class="totalField form-control form-control-sm" placeholder="Default: 100" />
                </div>
              </div>
            </div>
          </div>

          <div id="get-browser-key" class="gjs-container" style="display: none;">
            <div class="gjs-row">
              <div id="entityCollection-label-div" class="gjs-label-wrp">
                <div class="gjs-label" title="Collection Name">Collection Name</div>
              </div>
              <div id="browserStorageKeyDiv" class="gjs-field-wrp gjs-field-wrp--json-field-progressTotal-div" style="display: none;">
                <div class="gjs-field">
                  <select class="browserStorageKey form-control form-control-sm options-light"> </select>
                </div>
              </div>
            </div>
             <div class="gjs-row">
              <div id="entityField-label-div" class="gjs-label-wrp">
                <div class="gjs-label" title="Field Name">Field Name</div>
              </div>
              <div id="browserStorageFieldDiv" class="gjs-field-wrp gjs-field-wrp--json-field-progressTotal-div" style="display: none;">
                <div class="gjs-field">
                  <select class="browserStorageFieldKey form-control form-control-sm options-light"> </select>
                </div>
              </div>
            </div>
          </div>

          <div id="get-progressTotal-field-container" class="gjs-container" style="display: none;">
            <div class="gjs-row">
              <div id="field-label-progressTotal-div" class="gjs-label-wrp">
                <div class="gjs-label" title="Field Name">Field Name</div>
              </div>
              <div id="collection-label-progressTotal-div" class="gjs-label-wrp" style="display: none;">
                <div class="gjs-label" title="Collection Name">Collection Name</div>
              </div>
              <div id="select-progressTotal-div" class="gjs-field-wrp gjs-field-wrp--select-progressTotal-div" style="display: none;">
                <div class="gjs-field gjs-field--select-progressTotal-div">
                  <select class="selectprogressTotalField form-control form-control-sm options-light"> </select>
                </div>
              </div>
              <div id="json-field-progressTotal-div" class="gjs-field-wrp gjs-field-wrp--json-field-progressTotal-div" style="display: none;">
                <div class="gjs-field">
                  <input class="jsonFieldprogressTotal form-control form-control-sm" placeholder="Ex. name" />
                </div>
              </div>
            </div>
          </div>
        </div>
    `;

        const totalDiv = el.querySelector('#total-div');
        const totalField = el.querySelector('.totalField');

        const selectGetTextFrom = el.querySelector('.select-getprogressTotalFrom');
        const getContentFieldContainer = el.querySelector('#get-progressTotal-field-container');
        const getBrowserKey = el.querySelector('#get-browser-key');

        const fieldLabelDiv = el.querySelector('#field-label-progressTotal-div');
        const collectionLabelDiv = el.querySelector('#collection-label-progressTotal-div');
        const selectFieldDiv = el.querySelector('#select-progressTotal-div');
        const selectprogressTotalField = el.querySelector('.selectprogressTotalField');

        const jsonFieldDiv = el.querySelector('#json-field-progressTotal-div');
        const jsonFieldprogressTotal = el.querySelector('.jsonFieldprogressTotal');
        const browserStorageKeyDiv = el.querySelector('#browserStorageKeyDiv');
        const browserStorageKey = el.querySelector('.browserStorageKey');
        const browserStorageFieldDiv = el.querySelector('#browserStorageFieldDiv');
        const browserStorageFieldKey = el.querySelector('.browserStorageFieldKey');
        jsonFieldprogressTotal.addEventListener('change', async (ev) => {});
        totalField.addEventListener('change', async (ev) => {});
        if (selectGetTextFrom) {
          selectGetTextFrom.addEventListener('change', async (ev) => {
            selectprogressTotalField.innerHTML = '';
            let optionHtml = `<option value="" selected>None</option>`;
            if (selectGetTextFrom.value) {
              getContentFieldContainer.style.display = 'block';
              if (selectGetTextFrom.value === 'browserStorage') {
                getBrowserKey.style.display = 'block';
              } else {
                getBrowserKey.style.display = 'none';
              }
            } else {
              getContentFieldContainer.style.display = 'none';
            }
            if (selectGetTextFrom.value === 'session') {
              optionHtml = session ? getFieldOptionsForProgressSelect(session.options) : '';
              selectFieldDiv.style.display = 'block';
              fieldLabelDiv.style.display = 'block';
              jsonFieldDiv.style.display = 'none';
              collectionLabelDiv.style.display = 'none';
              totalDiv.style.display = 'none';
            } else if (selectGetTextFrom.value === 'sessionTenant') {
              optionHtml = sessionTenant
                ? getFieldOptionsForProgressSelect(sessionTenant.options)
                : '';
              selectFieldDiv.style.display = 'block';
              fieldLabelDiv.style.display = 'block';
              jsonFieldDiv.style.display = 'none';
              collectionLabelDiv.style.display = 'none';
              totalDiv.style.display = 'none';
            } else if (selectGetTextFrom.value === 'sessionUserSettings') {
              optionHtml = sessionUserSettings
                ? getFieldOptionsForProgressSelect(sessionUserSettings.options)
                : '';
              selectFieldDiv.style.display = 'block';
              fieldLabelDiv.style.display = 'block';
              jsonFieldDiv.style.display = 'none';
              collectionLabelDiv.style.display = 'none';
              totalDiv.style.display = 'none';
            } else if (selectGetTextFrom.value === 'sessionSubTenant') {
              optionHtml = sessionSubTenant
                ? getFieldOptionsForProgressSelect(sessionSubTenant.options)
                : '';
              selectFieldDiv.style.display = 'block';
              fieldLabelDiv.style.display = 'block';
              jsonFieldDiv.style.display = 'none';
              collectionLabelDiv.style.display = 'none';
              totalDiv.style.display = 'none';
            } else if (selectGetTextFrom.value === 'collection') {
              optionHtml = collection ? getFieldOptionsForProgressSelect(collection.options) : '';
              selectFieldDiv.style.display = 'block';
              fieldLabelDiv.style.display = 'block';
              jsonFieldDiv.style.display = 'none';
              collectionLabelDiv.style.display = 'none';
              totalDiv.style.display = 'none';
            } else if (
              ['previousActionResponse', 'previousActionFormData'].includes(selectGetTextFrom.value)
            ) {
              jsonFieldDiv.style.display = 'block';
              fieldLabelDiv.style.display = 'block';
              selectFieldDiv.style.display = 'none';
              collectionLabelDiv.style.display = 'none';
              totalDiv.style.display = 'none';
            } else if (selectGetTextFrom.value === 'browserStorage') {
              browserStorageKey.innerHTML = collections
                ? getCollectionOptionsForSelect(collections)
                : '';
              browserStorageFieldKey.innerHTML = `<option value="" selected>None</option>`;
              browserStorageFieldDiv.style.display = 'block';
              browserStorageKeyDiv.style.display = 'block';
              selectFieldDiv.style.display = 'none';
              collectionLabelDiv.style.display = 'none';
              jsonFieldDiv.style.display = 'none';
              fieldLabelDiv.style.display = 'none';
              totalDiv.style.display = 'none';
            } else if (selectGetTextFrom.value === 'FIXED') {
              totalDiv.style.display = 'block';
              jsonFieldDiv.style.display = 'none';
              selectFieldDiv.style.display = 'none';
              fieldLabelDiv.style.display = 'none';
              collectionLabelDiv.style.display = 'none';
              getContentFieldContainer.style.display = 'none';
              getBrowserKey.style.display = 'none';
            } else {
              jsonFieldDiv.style.display = 'none';
              selectFieldDiv.style.display = 'none';
              fieldLabelDiv.style.display = 'none';
              collectionLabelDiv.style.display = 'none';
              getContentFieldContainer.style.display = 'none';
              getBrowserKey.style.display = 'none';
              totalDiv.style.display = 'none';
            }
            jsonFieldprogressTotal.value = '';
            browserStorageKey.value = '';
            selectprogressTotalField.innerHTML = optionHtml;
          });
        }
        browserStorageKey.addEventListener('change', async (ev) => {
          const selectedCollection = collections.find(
            (col) => col.collectionName === ev.target.value,
          );
          const fields = await getCollectionFieldTraitOptions(selectedCollection, collections);
          browserStorageFieldKey.innerHTML = getFieldOptionsForProgressSelect(fields);
        });
        return el;
      },
      onEvent({ elInput, component }) {
        const select = elInput.querySelector('.selectprogressTotalField');
        const selectFieldDiv = elInput.querySelector('#select-progressTotal-div');
        const jsonFieldprogressTotal = elInput.querySelector('.jsonFieldprogressTotal');
        const browserStorageKey = elInput.querySelector('.browserStorageKey');
        const browserStorageFieldKey = elInput.querySelector('.browserStorageFieldKey');
        const selectGetTextFrom = document.querySelector('.select-getprogressTotalFrom');
        const selectGetTextFromValue = selectGetTextFrom ? selectGetTextFrom.value : '';
        let selectFieldValue = select.value || '';
        let jsonFieldValue = jsonFieldprogressTotal.value || '';
        let browserStorageKeyValue = browserStorageKey.value || '';
        let browserStorageFieldKeyValue = browserStorageFieldKey.value || '';
        const selectedOption = select.options[select.selectedIndex];
        const fieldType = selectedOption ? selectedOption.getAttribute('type') : 'text';

        const totalField = elInput.querySelector('.totalField');
        const totalFieldValue = totalField.value || '';

        if (selectFieldValue.includes("'")) {
          selectFieldValue = selectFieldValue.split("'").join('"');
        }

        if (selectGetTextFromValue) {
          component.set('getContentFrom', selectGetTextFromValue);
          let attr = component.getAttributes();
          [
            progressTotalCollectionFieldName,
            progressTotalSessionFieldName,
            progressTotalSessionTenantFieldName,
            progressTotalSessionUserSettingsFieldName,
            progressTotalSessionSubTenantFieldName,
            progressTotalPreviousActionFormdata,
            progressTotalPreviousActionResponse,
            progressTotalBrowserStorage,
            progressTotalStorageKey,
            'progress-total',
          ].forEach((key) => {
            if (attr[key]) delete attr[key];
          });
          attr['data-row'] = 'generated';
          component.setAttributes(attr);
          if (selectFieldValue && selectGetTextFromValue === 'session') {
            component.addAttributes({ [progressTotalSessionFieldName]: selectFieldValue });
          } else if (selectGetTextFromValue === 'FIXED') {
            const total = totalFieldValue ? totalFieldValue : 100;
            component.addAttributes({ 'progress-total': total });
          } else if (selectFieldValue && selectGetTextFromValue === 'sessionTenant') {
            component.addAttributes({ [progressTotalSessionTenantFieldName]: selectFieldValue });
          } else if (selectFieldValue && selectGetTextFromValue === 'sessionUserSettings') {
            component.addAttributes({
              [progressTotalSessionUserSettingsFieldName]: selectFieldValue,
            });
          } else if (selectFieldValue && selectGetTextFromValue === 'sessionSubTenant') {
            component.addAttributes({
              [progressTotalSessionSubTenantFieldName]: selectFieldValue,
            });
          } else if (selectGetTextFromValue === 'collection') {
            if (selectFieldValue) {
              component.addAttributes({
                [progressTotalCollectionFieldName]: selectFieldValue,
                'data-field-type': fieldType,
              });
            }
          } else if (selectGetTextFromValue === 'previousActionResponse') {
            attr[progressTotalPreviousActionResponse] = jsonFieldValue ? jsonFieldValue : attr.name;
            delete attr[progressTotalCollectionFieldName];
            delete attr[progressTotalPreviousActionFormdata];
            delete attr[progressTotalBrowserStorage];
            component.setAttributes(attr);
            selectFieldDiv.style.display = 'none';
          } else if (selectGetTextFromValue === 'previousActionFormData') {
            attr[progressTotalPreviousActionFormdata] = jsonFieldValue ? jsonFieldValue : attr.name;
            delete attr[progressTotalCollectionFieldName];
            delete attr[progressTotalPreviousActionResponse];
            delete attr[progressTotalBrowserStorage];
            component.setAttributes(attr);
            selectFieldDiv.style.display = 'none';
          } else if (selectGetTextFromValue === 'browserStorage') {
            attr[progressTotalBrowserStorage] = browserStorageFieldKeyValue
              ? browserStorageFieldKeyValue
              : attr.name;
            attr[progressTotalStorageKey] = browserStorageKeyValue
              ? `entity_${browserStorageKeyValue}`
              : attr.name;
            delete attr[progressTotalCollectionFieldName];
            delete attr[progressTotalPreviousActionFormdata];
            delete attr[progressTotalPreviousActionResponse];
            component.setAttributes(attr);
            selectFieldDiv.style.display = 'none';
          }
        } else {
          const attr = component.getAttributes();
          delete attr[progressTotalSessionFieldName];
          delete attr[progressTotalSessionTenantFieldName];
          delete attr[progressTotalSessionUserSettingsFieldName];
          delete attr[progressTotalSessionSubTenantFieldName];
          delete attr[progressTotalCollectionFieldName];
          delete attr['data-field-type'];
          delete attr[progressTotalPreviousActionResponse];
          delete attr[progressTotalPreviousActionFormdata];
          delete attr[progressTotalBrowserStorage];
          delete attr[progressTotalStorageKey];
          component.setAttributes(attr);
          component.set('getContentFrom', '');
        }
      },
      async onUpdate({ elInput, component }) {
        const attr = component.getAttributes();
        //Removes empty attribute key
        delete attr[''];
        const getContentFrom = component.get('getContentFrom');
        const selectFieldDiv = elInput.querySelector('#select-progressTotal-div');
        const selectprogressTotalField = elInput.querySelector('.selectprogressTotalField');
        const getContentFieldContainer = elInput.querySelector(
          '#get-progressTotal-field-container',
        );
        const getBrowserKey = elInput.querySelector('#get-browser-key');
        const fieldLabelDiv = elInput.querySelector('#field-label-progressTotal-div');
        const collectionLabelDiv = elInput.querySelector('#collection-label-progressTotal-div');
        const jsonFieldDiv = elInput.querySelector('#json-field-progressTotal-div');
        const jsonFieldprogressTotal = elInput.querySelector('.jsonFieldprogressTotal');
        const selectGetTextFrom = elInput.querySelector('.select-getprogressTotalFrom');

        const browserStorageKeyDiv = elInput.querySelector('#browserStorageKeyDiv');
        const browserStorageKey = elInput.querySelector('.browserStorageKey');
        const browserStorageFieldDiv = elInput.querySelector('#browserStorageFieldDiv');
        const browserStorageFieldKey = elInput.querySelector('.browserStorageFieldKey');
        let previousActionFormDataValue = attr[progressTotalPreviousActionFormdata] || '';
        let previousActionResponseFieldValue = attr[progressTotalPreviousActionResponse] || '';
        let entityStorageValue = attr[progressTotalBrowserStorage] || '';
        let storageKeyValue = attr[progressTotalStorageKey] || '';
        let jsonFieldValue = '';
        let browserStorageKeyValue = '';
        let browserStorageFieldKeyValue = '';
        if (selectGetTextFrom) {
          selectGetTextFrom.value = getContentFrom || '';
        }

        if (
          previousActionFormDataValue ||
          previousActionResponseFieldValue ||
          entityStorageValue ||
          storageKeyValue
        ) {
          if (previousActionFormDataValue) {
            jsonFieldValue = previousActionFormDataValue;
          } else if (previousActionResponseFieldValue) {
            jsonFieldValue = previousActionResponseFieldValue;
          } else if (entityStorageValue || storageKeyValue) {
            browserStorageKeyValue = storageKeyValue.replace('entity_', '');
            browserStorageFieldKeyValue = entityStorageValue;
          }
        }

        const sessionFieldValue = attr[progressTotalSessionFieldName] || '';
        const sessionTenantFieldValue = attr[progressTotalSessionTenantFieldName] || '';
        const sessionUserSettingsFieldValue = attr[progressTotalSessionUserSettingsFieldName] || '';
        const sessionSubTenantFieldValue = attr[progressTotalSessionSubTenantFieldName] || '';
        const collectionFieldValue = attr[progressTotalCollectionFieldName] || '';

        const totalDiv = elInput.querySelector('#total-div');
        const totalField = elInput.querySelector('.totalField');
        const totalFieldValue = attr['progress-total'];

        if (getContentFrom) {
          getContentFieldContainer.style.display = 'block';
          let optionHtml = `<option value="" >None</option>`;
          switch (getContentFrom) {
            case 'FIXED':
              totalField.value = totalFieldValue ? totalFieldValue : 100;
              totalDiv.style.display = 'block';
              fieldLabelDiv.style.display = 'none';
              break;
            case 'session':
              selectFieldDiv.style.display = 'block';
              optionHtml = session ? getFieldOptionsForProgressSelect(session.options) : '';
              selectprogressTotalField.innerHTML = optionHtml;
              selectprogressTotalField.value = sessionFieldValue;
              totalDiv.style.display = 'none';
              break;
            case 'sessionTenant':
              selectFieldDiv.style.display = 'block';
              optionHtml = sessionTenant
                ? getFieldOptionsForProgressSelect(sessionTenant.options)
                : '';
              selectprogressTotalField.innerHTML = optionHtml;
              selectprogressTotalField.value = sessionTenantFieldValue;
              totalDiv.style.display = 'none';
              break;
            case 'sessionUserSettings':
              selectFieldDiv.style.display = 'block';
              optionHtml = sessionUserSettings
                ? getFieldOptionsForProgressSelect(sessionUserSettings.options)
                : '';
              selectprogressTotalField.innerHTML = optionHtml;
              selectprogressTotalField.value = sessionUserSettingsFieldValue;
              totalDiv.style.display = 'none';
              break;
            case 'sessionSubTenant':
              selectFieldDiv.style.display = 'block';
              optionHtml = sessionSubTenant
                ? getFieldOptionsForProgressSelect(sessionSubTenant.options)
                : '';
              selectprogressTotalField.innerHTML = optionHtml;
              selectprogressTotalField.value = sessionSubTenantFieldValue;
              totalDiv.style.display = 'none';
              break;
            case 'collection':
              selectFieldDiv.style.display = 'block';
              optionHtml = collection ? getFieldOptionsForProgressSelect(collection.options) : '';
              selectprogressTotalField.innerHTML = optionHtml;
              selectprogressTotalField.value = collectionFieldValue;
              totalDiv.style.display = 'none';
              break;
            case 'previousActionResponse':
            case 'previousActionFormData':
              jsonFieldDiv.style.display = 'block';
              jsonFieldprogressTotal.value = jsonFieldValue;
              totalDiv.style.display = 'none';
              break;
            case 'browserStorage':
              getBrowserKey.style.display = 'block';
              browserStorageKeyDiv.style.display = 'block';
              browserStorageFieldDiv.style.display = 'block';
              fieldLabelDiv.style.display = 'none';
              browserStorageKey.innerHTML = collections
                ? getCollectionOptionsForSelect(collections)
                : '';
              browserStorageKey.value = browserStorageKeyValue;
              const entityCollection = collections.find(
                (col) => col.collectionName === browserStorageKeyValue,
              );
              const fields = await getCollectionFieldTraitOptions(entityCollection, collections);
              browserStorageFieldKey.innerHTML = getFieldOptionsForProgressSelect(fields);
              browserStorageFieldKey.value = browserStorageFieldKeyValue;
              totalDiv.style.display = 'none';
              break;
            default:
              jsonFieldDiv.style.display = 'none';
              selectFieldDiv.style.display = 'none';
              collectionLabelDiv.style.display = 'none';
              totalDiv.style.display = 'none';
              break;
          }
        } else {
          getContentFieldContainer.style.display = 'none';
          jsonFieldDiv.style.display = 'none';
          selectFieldDiv.style.display = 'none';
          collectionLabelDiv.style.display = 'none';
          totalDiv.style.display = 'none';
        }
      },
    });
  }
}
